module.exports = __webpack_public_path__ + "img/pantsar.33c7b0b2.png";